import { Component , Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { NudgeService } from 'src/app/_shared/providers/nudges/nudge.service';
import { BroadcastMessageData } from 'src/app/app.interfaces';

@Component({
  selector: 'app-snackbar-nudge',
  templateUrl: './snackbar-nudge.component.html',
  styleUrls: ['./snackbar-nudge.component.scss']
})

export class SnackbarNudgeComponent{
  totalMessages: number = 0;
  messageSubscription = new Subscription();

  constructor(
    public snackBarRef: MatSnackBarRef<SnackbarNudgeComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: BroadcastMessageData,
    private _nudgeService : NudgeService,
  ) 
  {
    this.messageSubscription.add(this._nudgeService.totalMessages.subscribe((data : number) => {
      this.totalMessages = data;
    }));
  }

  // Dismisses the snackbar and opens the next nudge if any.
  dismiss(): void {
    this.snackBarRef.dismiss();
    this.messageSubscription.unsubscribe();
  }
}
